import { useState } from "react";

import { widgetHoverAtom } from "atoms/interaction";
import { useChartsContext } from "contexts";
import { useAtomValue } from "jotai";

import { useChartEntities } from "hooks/charts";

import { XAxisContainer } from "./XAxisContainer";
import { YAxisContainer } from "./YAxisContainer";

export function AxisContainer() {
  const widgetHoverMap = useAtomValue(widgetHoverAtom);
  const { id } = useChartsContext();
  const isHover = widgetHoverMap?.[id] ?? false;
  const {
    screenshot,
    dataTable,
    multiProduct,
    options: optionString
  } = useChartEntities(id);

  const [userInputOpened, setUserInputOpened] = useState(false);

  const showAxis =
    !screenshot?.active && !dataTable?.active && (isHover || userInputOpened);
  const isMultiProductActive = multiProduct?.active;

  if (!optionString || optionString.length === 0) return null;

  let options;

  try {
    options = JSON.parse(optionString);
  } catch {
    return null;
  }

  const xAxisArray = Array.isArray(options.xAxis) ? options.xAxis : [options.xAxis];
  const yAxisArray = Array.isArray(options.yAxis) ? options.yAxis : [options.yAxis];

  return (
    showAxis && (
      <>
        <XAxisContainer
          onInputStateChange={setUserInputOpened}
          isMultiProductActive={isMultiProductActive}
          xAxisArray={xAxisArray}
        />
        <YAxisContainer
          onInputStateChange={setUserInputOpened}
          isMultiProductActive={isMultiProductActive}
          yAxisArray={yAxisArray}
        />
      </>
    )
  );
}
